

$body.on("click",".infos [data-prev-next-poster]",function(e){

    e.preventDefault();
    e.stopPropagation();

    let $a=$(this);
    let $all=$(this).closest(".poster-top").find("[data-poster-nb]");
    let $nb= $a.attr("data-prev-next-poster");



    let $active = $(this).closest(".poster-top").find("[data-poster-nb='"+$nb+"']");
    let $last = $(this).closest(".poster-top").find(".diapo .active");


    if($all.is(".active")){
        $all.removeClass("active");
    }

    if($all.is(".last")){
        $all.removeClass("last");
    }

    $active.addClass("active");
    $last.addClass("last");

    setTimeout(function(){
        $last.removeClass("last");
    },1001);



});


// WEBPACK FOOTER //
// ./project/_src/components/poster-top.js